export default "__VITE_ASSET__c7532aec__"